import React, { useState } from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  Menu, 
  MenuItem, 
 
  Container,
  Link,
  Stack
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

interface NavItem {
  label: string;
  items?: string[];
  href?: string;
}

const navItems: NavItem[] = [
  {
    label: 'Our Products',
    items: ['QixDeploy', 'QixScreener']
  },
  {
    label: 'Services',
    href: '/services'
  },
  {
    label: 'Game Development',
    href: '/gamedev'
  },
   
  // {
  //   label: 'Industries',
  //   href: '/industries'
  // },
  // {
  //   label: 'About',
  //   href: '/about'
  // },
  // {
  //   label: 'Blog',
  //   href: '/blog'
  // },
  // {
  //   label: 'Careers',
  //   href: '/careers'
  // }
];

export const Navbar: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [activeMenu, setActiveMenu] = useState<string | null>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, label: string) => {
    setAnchorEl(event.currentTarget);
    setActiveMenu(label);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveMenu(null);
  };

  const textGradientStyle = {
    background: 'linear-gradient(45deg, #2563eb 30%, #3b82f6 90%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    fontWeight: 600
  };

  return (
    <AppBar 
      position="fixed" 
      sx={{ 
        bgcolor: 'background.default',
        backdropFilter: 'blur(20px)',
        borderBottom: '1px solid',
        borderColor: 'divider',
        boxShadow: 'none'
      }}
    >
      <Container maxWidth="lg">
        <Toolbar sx={{ py: 1 }}>
          {/* Logo */}
          <Link
            href="/"
            underline="none"
            sx={{
              display: 'flex',
              alignItems: 'center',
              transition: 'opacity 0.2s',
              '&:hover': {
                opacity: 0.8
              }
            }}
          >
            <Typography 
              variant="h5" 
              component="div" 
              sx={{ 
                
                ...textGradientStyle
              }}
            >
              Qixbi
            </Typography>
          </Link>

          {/* Right-aligned menu items */}
          <Stack 
            direction="row" 
            spacing={0.5} 
            alignItems="center"
            sx={{ 
              ml: 'auto'
            }}
          >
            {navItems.map((item) => (
              item.items ? (
                <div key={item.label}>
                  <Button
                    endIcon={<KeyboardArrowDownIcon />}
                    onClick={(e) => handleMenuOpen(e, item.label)}
                    sx={{
                      textTransform: 'none',
                      px: 2,
                      mx: 0.5,
                      ...textGradientStyle,
                      '&:hover': {
                        bgcolor: 'action.hover'
                      }
                    }}
                  >
                    {item.label}
                  </Button>
                  <Menu
                    anchorEl={anchorEl}
                    open={activeMenu === item.label}
                    onClose={handleMenuClose}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        mt: 1.5,
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.1))',
                        '& .MuiMenuItem-root': {
                          px: 2,
                          py: 1.5,
                          ...textGradientStyle
                        },
                        '&:before': {
                          content: '""',
                          display: 'block',
                          position: 'absolute',
                          top: 0,
                          right: 20,
                          width: 10,
                          height: 10,
                          bgcolor: 'background.paper',
                          transform: 'translateY(-50%) rotate(45deg)',
                          zIndex: 0,
                        },
                      },
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                  >
                    {item.items.map((subItem) => (
                      <MenuItem 
                        key={subItem} 
                        onClick={handleMenuClose}
                        sx={{
                          transition: 'background-color 0.2s',
                          '&:hover': {
                            bgcolor: 'action.hover'
                          }
                        }}
                      >
                        {subItem}
                      </MenuItem>
                    ))}
                  </Menu>
                </div>
              ) : (
                <Button
                  key={item.label}
                  href={item.href}
                  sx={{
                    textTransform: 'none',
                    px: 2,
                    mx: 0.5,
                    ...textGradientStyle,
                    '&:hover': {
                      bgcolor: 'action.hover'
                    }
                  }}
                >
                  {item.label}
                </Button>
              )
            ))}

            <Button 
              variant="contained" 
              href="/contact"
              sx={{
                textTransform: 'none',
                px: 3,
                py: 1,
                ml: 2,
                borderRadius: 2,
                boxShadow: 'none',
                background: 'linear-gradient(45deg, #2563eb 30%, #3b82f6 90%)',
                color: 'white',
                transition: 'transform 0.2s, box-shadow 0.2s',
                '&:hover': {
                  boxShadow: '0 4px 12px rgba(37, 99, 235, 0.2)',
                  transform: 'translateY(-1px)'
                }
              }}
            >
              Contact Us
            </Button>
          </Stack>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;